import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=5da71f1e&scoped=true&functional=true&"
var script = {}
import style0 from "./Sources.vue?vue&type=style&index=0&id=5da71f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5da71f1e",
  null
  
)

component.options.__file = "Sources.vue"
export default component.exports